export var datepickerCalendarHeaderStyles = {
  root: function root(_ref) {
    var v = _ref.variables;
    return {
      display: 'flex',
      alignItems: 'center',
      paddingTop: v.calendarHeaderPaddingTop,
      paddingBottom: v.calendarHeaderPaddingBottom
    };
  },
  label: function label(_ref2) {
    var v = _ref2.variables;
    return {
      fontWeight: v.calendarHeaderLabelFontWeight,
      flexGrow: 1,
      paddingLeft: v.calendarHeaderLabelPaddingLeft
    };
  }
};
//# sourceMappingURL=datepickerCalendarHeaderStyles.js.map
